const NODE_ENV = process.env.REACT_APP_ENV || 'staging'
const WEB_TYPE = process.env.WEB_TYPE || 'visitor'

let apiBaseUrl = ''
let publicPath = ''
let fbAppId = ''
let gaId = ''
let gtmId = ''
let gtagId = ''
let chatUrl = ''
let linkVisitor = ''
let linkLearning = ''
let linkParent = ''
let sourceMaps = false
let firebaseConfig = null

switch (NODE_ENV) {
  case 'development':
    sourceMaps = false
    apiBaseUrl = 'http://api2.kynaforkids.local/'
    fbAppId = '158484694991116'
    gtmId = 'GTM-TKXN2P8'
    gaId = 'UA-131293252-1'
    gtagId = 'AW-800519148'
    chatUrl = 'http://localhost:8080'
    publicPath = '/'
    linkVisitor = 'http://localhost:3000'
    linkLearning = 'http://localhost:3001'
    linkParent = 'http://localhost:3000/khoa-hoc-cho-bo-me'
    firebaseConfig = {
      apiKey: 'AIzaSyBVF5xbn4dMEL8GcZON7TzgTphRwMRR3JY',
      authDomain: 'kynaforkids-server-development.firebaseapp.com',
      databaseURL: 'https://kynaforkids-server-development.firebaseio.com',
      projectId: 'kynaforkids-server-development',
      storageBucket: 'kynaforkids-server-development.appspot.com',
      messagingSenderId: '822577483975',
      appId: '1:822577483975:web:c682522118bd9aa4b1aee2',
      measurementId: 'G-0E6H3XDJJZ'
    }
    break
  case 'local':
    sourceMaps = true
    apiBaseUrl = 'http://api.kynaforkids.local/'
    fbAppId = '158484694991116'
    gaId = 'UA-116965254-1'
    gtmId = 'GTM-TKXN2P8'
    gtagId = 'AW-800519148'
    chatUrl = 'http://localhost:8080'
    publicPath = '/'
    linkVisitor = 'http://kynaforkids.local'
    linkLearning = 'http://learning.kynaforkids.local'
    linkParent = 'http://kynaforkids.local/khoa-hoc-cho-bo-me'
    firebaseConfig = {
      apiKey: 'AIzaSyBVF5xbn4dMEL8GcZON7TzgTphRwMRR3JY',
      authDomain: 'kynaforkids-server-development.firebaseapp.com',
      databaseURL: 'https://kynaforkids-server-development.firebaseio.com',
      projectId: 'kynaforkids-server-development',
      storageBucket: 'kynaforkids-server-development.appspot.com',
      messagingSenderId: '822577483975',
      appId: '1:822577483975:web:c682522118bd9aa4b1aee2',
      measurementId: 'G-0E6H3XDJJZ'
    }
    break
  case 'dev':
    sourceMaps = true
    apiBaseUrl = 'https://api-dev.kynaforkids.vn/'
    publicPath = '/'
    fbAppId = '158484694991116'
    gaId = 'UA-116965254-1'
    gtmId = 'GTM-TKXN2P8'
    gtagId = 'AW-800519148'
    chatUrl = 'https://chat-dev.kynaforkids.vn'
    linkVisitor = 'https://dev.kynaforkids.vn'
    linkLearning = 'https://learning-dev.kynaforkids.vn'
    linkParent = 'https://dev.kynaforkids.vn/khoa-hoc-cho-bo-me'
    firebaseConfig = {
      apiKey: 'AIzaSyBVF5xbn4dMEL8GcZON7TzgTphRwMRR3JY',
      authDomain: 'kynaforkids-server-development.firebaseapp.com',
      databaseURL: 'https://kynaforkids-server-development.firebaseio.com',
      projectId: 'kynaforkids-server-development',
      storageBucket: 'kynaforkids-server-development.appspot.com',
      messagingSenderId: '822577483975',
      appId: '1:822577483975:web:c682522118bd9aa4b1aee2',
      measurementId: 'G-0E6H3XDJJZ'
    }
    break
  case 'staging':
    sourceMaps = true
    apiBaseUrl = 'https://api-staging.kynaforkids.vn/'
    publicPath = '/'
    fbAppId = '158484694991116'
    gaId = 'UA-116965254-1'
    // gaId = 'UA-116287707-2'
    gtmId = 'GTM-TKXN2P8'
    gtagId = 'AW-800519148'
    chatUrl = 'https://chat-staging.kynaforkids.vn'
    linkVisitor = 'https://staging.kynaforkids.vn'
    linkLearning = 'https://learning-staging.kynaforkids.vn'
    linkParent = 'https://staging.kynaforkids.vn/khoa-hoc-cho-bo-me'
    firebaseConfig = {
      apiKey: 'AIzaSyBVF5xbn4dMEL8GcZON7TzgTphRwMRR3JY',
      authDomain: 'kynaforkids-server-development.firebaseapp.com',
      databaseURL: 'https://kynaforkids-server-development.firebaseio.com',
      projectId: 'kynaforkids-server-development',
      storageBucket: 'kynaforkids-server-development.appspot.com',
      messagingSenderId: '822577483975',
      appId: '1:822577483975:web:c682522118bd9aa4b1aee2',
      measurementId: 'G-0E6H3XDJJZ'
    }
    break
  case 'production':
    sourceMaps = false
    apiBaseUrl = 'https://api.kynaenglish.com/'
    publicPath = '/'
    fbAppId = '158484694991116'
    gaId = 'UA-116965254-1'
    gtmId = 'GTM-TKXN2P8'
    gtagId = 'AW-800519148'
    chatUrl = 'https://chat.kynaforkids.vn'
    linkVisitor = 'https://kynaforkids.vn'
    linkLearning = 'https://kynalearning.com'
    linkParent = 'https://kynaforkids.vn/khoa-hoc-cho-bo-me'
    firebaseConfig = {
      apiKey: 'AIzaSyCZF0RV6bXuXWxzioGYc-VCQZE6qhrBaaM',
      authDomain: 'kynaforkids-server-production.firebaseapp.com',
      databaseURL: 'https://kynaforkids-server-production.firebaseio.com',
      projectId: 'kynaforkids-server-production',
      storageBucket: 'kynaforkids-server-production.appspot.com',
      messagingSenderId: '512872789144',
      appId: '1:512872789144:web:ff2dce70fa0b6576c88ced',
      measurementId: 'G-C8NTRM1FN1'
    }
    break
  default:
    break
}
module.exports = {
  /** The environment to use when building the project */
  env: NODE_ENV,
  /** The web type to use when building the project */
  webType: WEB_TYPE,
  /** The full path to the project's root directory */
  basePath: __dirname,
  /** The name of the directory containing the application source code */
  srcDir: 'src',
  /** The file name of the application's entry point */
  main: 'main',
  /** The name of the directory in which to emit compiled assets */
  outDir: 'dist',
  /** The name of the directory in which to point web index */
  webDir: 'web',
  /** The base path for all projects* assets (relative to the website root) */
  publicPath,
  /** Whether to generate sourcemaps */
  sourcemaps: sourceMaps,
  /** A hash map of keys that the compiler should treat as external to the project */
  externals: {},
  /** A hash map of variables and their values to expose globally */
  globals: {},
  /** Whether to enable verbose logging */
  verbose: false,
  /** Environment api */
  apiBaseUrl,
  /** Facebook App Id */
  fbAppId,
  /** Google trackingid */
  gaID: gaId,
  /** Google tag manager */
  gtmId,
  gtagId,
  /** Chat configuration */
  chatUrl,
  /** The list of modules to bundle separately from the core application code */
  vendors: [
    'react',
    'react-dom',
    'redux',
    'react-redux',
    'redux-thunk',
    'react-router',
  ],
  linkVisitor,
  linkLearning,
  linkParent,
  firebaseConfig,
}